import Cookies from "js-cookie";

const HISTORY_COOKIE_NAME = "RepublicaTransferHistory";

/////// END EMAIL ////////////


/////// TRANSFER HISTORY ////////////

function saveTransferHistory(list) {
  Cookies.set(HISTORY_COOKIE_NAME, JSON.stringify(list), {
    path: "/",
    expires: 30 // cookie lifespan (not per-item!) /// 30 days
  });
}

/**
 * Add an item that expires in X DAYS
 */
export function addCookieTransferHistory(transferId, expireDays) {
  
  const list = JSON.parse(Cookies.get(HISTORY_COOKIE_NAME) || "[]");

  const now = Date.now();
  const expiresAt = now + expireDays * 24 * 60 * 60 * 1000; // days → ms

  list.push({
    transferId,
    createdAt: now,
    expiresAt: expiresAt
  });
  
  //cookie seems to only support like... 27 elements... (4kb) limit to 20 latest
  list.sort((a, b) => b.createdAt - a.createdAt);

  var slice = list.slice(0,20);
  saveTransferHistory(slice);
}


/**
 * Get items, ordered by createdAt DESC
 * Removes items where expiresAt < now
 */
export function getCookieTransferHistory() {  

  const now = Date.now();

  const list = JSON.parse(Cookies.get(HISTORY_COOKIE_NAME) || "[]");

  const filtered = list.filter(item => item.expiresAt > now);

  filtered.sort((a, b) => b.createdAt - a.createdAt);

  saveTransferHistory(filtered);

  return filtered;
}

export function clearHistory() {
  Cookies.remove(HISTORY_COOKIE_NAME, { path: "/" });
}

/////// END TRANSFER HISTORY ////////////
